import DeleteConfirm from "@/components/Crud/Modals/Confirm";
import { mapState } from "vuex";
import moment from "moment";
import styles from "./styles.css"

import debounce from 'lodash/debounce';
import NotificationMenu from "../../Notification/NotificationMenu.vue";

function removeEmptyObject(obj, filter_values = [undefined]) {
  const item = { ...obj };

  for (let propName in item) {
    if (filter_values.includes(item[propName])) {
      delete item[propName];
    }
  }
  return item;
}

export default {
  name: "CrudList",
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    parentUrlKey: {
      type: String,
      default: "",
    },
    parentStoreName: {
      type: String,
      default: "",
    },
    parentStoreUrl: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Section Title",
    },
    storeName: {
      type: String,
      default: "",
    },
    canAdd: {
      type: Boolean,
      default: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canShow: {
      type: Boolean,
      default: false,
    },
    canRefundCoins: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    canRemove: {
      type: Boolean,
      default: false,
    },
    canSearch: {
      type: Boolean,
      default: false,
    },
    canExport: {
      type: Boolean,
      default: false,
    },
    canOther: {
      type: Boolean,
      default: false,
    },
    labelBack: {
      type: String,
      default: "Atras",
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    labelAddNew: {
      type: String,
      default: "Agregar Nuevo",
    },
    labelEdit: {
      type: String,
      default: "Editar",
    },
    labelShow: {
      type: String,
      default: "Detalle",
    },
    labelRefundCoins: {
      type: String,
      default: "Carga",
    },
    labelDelete: {
      type: String,
      default: "Eliminar",
    },
    labelExport: {
      type: String,
      default: "Exportar",
    },
    labelOther: {
      type: String,
      default: "",
    },
    labelModalDelete: {
      type: String,
      default: "Eliminar",
    },
    filters: {
      type: Object,
      default: () => { },
    },
    actions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    singleSelect: {
      type: Boolean,
      default: false,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    isRead: {
      type: Boolean,
      default: false,
    },
    titleDeleted: {
      type: String,
      default: "Eliminar el registro",
    },
    descriptionDeleted: {
      type: String,
      default: "¿Quieres eliminar este registro?",
    },
    labelModalCancel: {
      type: String,
      default: "",
    },
    labelModalConfirm: {
      type: String,
      default: "",
    },
    labelShowMore: {
      type: String,
      default: "Mostrar más",
    },
    nextLink: {
      type: String,
      default: "",
    },
  },
  components: { DeleteConfirm, NotificationMenu },
  watch: {
    async search(text) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(async () => {
        this.options = {
          ...this.options,
          search: text,
          page: 1
        };
        await this.$store.dispatch(this.storeName + "/getList", this.options).then((data) => {
          this.allItems = [...data];
          this.loading = false;
          this.empty_list = data.length === 0;
        });
      }, 600);
    },
    options: {
      async handler(val, old_val) {
        if (JSON.stringify(val) !== JSON.stringify(old_val)) {
          if (val.page > 1) {
            await this.$store.dispatch(this.storeName + "/getList", this.options).then((data) => {
              const uniqueNewItems = data.filter(
                newItem => !this.allItems.some(item => item.id === newItem.id)
              );
              this.allItems = [...this.allItems, ...uniqueNewItems];
              this.loading = false;
              this.empty_list = data.length === 0;
            });
          } else {
            await this.$store.dispatch(this.storeName + "/getList", this.options).then((data) => {
              this.allItems = [...data];
              this.loading = false;
              this.empty_list = data.length === 0;
            });
          }
        }
      },
      deep: true,
    },
    filters: {
      handler(items) {
        // Reiniciar página y lista al cambiar filtros
        const data_filter = removeEmptyObject(items);
        if (Object.keys(data_filter).length > 0) {
          this.options = {
            ...this.options,
            ...data_filter,
            page: 1,
          };
          this.allItems = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      token: this.$store.state["Authenticate"].token,
      search: "",
      selected_item: "",
      confirmDelete: false,
      options: {},
      //selected_rows: [],
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
      offset: true,
      page: 1,
      limit: 5,
      loading: false,
      empty_list: false,
      allItems: [],
      debounceTimer: null,
    };
  },
  async created() {
    if (this.$route.name != "") {
      // await this.getNotifications();
    }

    this.search = this.$store.state[this.storeName].options.search;

    this.options = {
      ...this.options,
      ...this.$store.state[this.storeName].options,
      search: this.$store.state[this.storeName].options.search,
    };
    if (this.parentUrlKey) {
      this.options[this.parentUrlKey] = this.$route.params[this.parentUrlKey];
    }
  },
  computed: {
    ...mapState({
      new_request_notifications: (state) =>
        state["Notifications_request_cms"].list_valid,
      total_valid: (state) => state["Notifications_request_cms"].total_valid,
      total_not_read: (state) =>
        state["Notifications_request_cms"].total_not_read,
    }),
    status() {
      return this.$store.state[this.storeName].status;
    },
    list() {
      return this.$store.state[this.storeName].list;
    },
    selected_rows() {
      return this.$store.state[this.storeName].selected_rows;
    },
    total() {
      return this.$store.state[this.storeName].total;
    },
    header() {
      return this.$store.state[this.storeName].header.map(item => {
        item.class = item.class ? item.class + " py-3" : "py-3";
        if (item.value == "actions") item.class = item.class + " text-end";
        return item
      });
    },
    api_url_store() {
      return this.$store.state[this.storeName].endpoint;
    },
    searchModel: {
      get() {
        return this.search ?? '';
      },
      set(val) {
        this.search = (val ?? '').trim();
      }
    },
  },
  methods: {
    updateTotal(newValue) {
      this.$store.commit(this.storeName + '/setTotal', { value: newValue });
    },
    onScroll: debounce(async function (event) {
      const bottom = event.target.scrollHeight - event.target.scrollTop <= event.target.clientHeight + 10;

      if (bottom && !this.loading) {
        this.loading = true;

        if (this.empty_list) {
          this.loading = false;
          return;
        }

        this.options = {
          ...this.options,
          page: this.options.page + 1
        }
      }
    }, 200),
    async getNotifications() {
      await this.$store.dispatch(
        "Notifications_request_cms/getListAllNotifications",
        {
          notification: "enable",
          is_read: false,
          is_new: true,
          page: 1,
          limit: 5,
        }
      );
    },
    notificationPagePrev() {
      this.page = this.page > 1 ? this.page - 1 : 1;
      this.$store.dispatch(
        "Notifications_request_cms/getListAllNotifications",
        {
          notification: "enable",
          is_read: false,
          is_new: true,
          page: this.page,
          limit: 5,
        }
      );
    },
    notificationPage() {
      this.page = this.page + 1;
      this.$store.dispatch(
        "Notifications_request_cms/getListAllNotifications",
        {
          notification: "enable",
          is_read: false,
          is_new: true,
          page: this.page,
          limit: 5,
        }
      );
    },
    getUserInitials(user) {
      if (user) {
        const complete_name = `${user.name || ""} ${user.last_name ||
          ""}`.trim();
        const nameParts = complete_name.split(" ");
        return nameParts
          .map((part) => part.charAt(0))
          .join("")
          .toUpperCase();
      }
      return "";
    },
    formatDateTime(date_time) {
      const date = new Date(date_time);
      return moment
        .utc(date)
        .local()
        .format("DD/MM/YYYY HH:mm:ss");
    },
    redirectToNotification(item) {
      this.$store.dispatch("Notifications_cms/show", item.id).then(() => {
        this.$store.dispatch(
          "Notifications_request_cms/getListAllNotifications",
          {
            notification: "enable",
            is_read: false,
            is_new: true,
            page: this.page,
            limit: 5,
          }
        );
      });

      if (item.type_notification === "new_spot") {
        this.$router
          .push("/admin/notifications_cms/edit/" + item.spot_id)
          .catch(null);
      } else if (item.type_notification === "new_spot_help") {
        this.$router
          .push("/admin/spot_helps/show/" + item.spot_help_id)
          .catch(null);
      } else if (item.type_notification === "cms-notification-extraction") {
        this.$router
          .push("/admin/request_extraction/edit/" + item.request_extraction_id)
          .catch(null);
        this.$store.dispatch("Notifications_request_cms/show", item.id);
      } else if (item.type_notification === "cms-need-sticker") {
        this.$router
          .push("/admin/notifications_request_cms/show/" + item.id)
          .catch(null);
      }
    },
    buildRootUrl() {
      if (this.parentUrlKey && this.parentStoreName) {
        return (
          "/admin/" +
          (this.parentStoreUrl || this.parentStoreName.toLowerCase()) +
          "/" +
          this.$route.params[this.parentUrlKey] +
          "/" +
          this.storeName.toLowerCase()
        );
      } else {
        return (
          "/admin/" + (this.parentStoreUrl || this.storeName.toLowerCase())
        );
      }
    },
    async addItem() {
      await this.$router.push(this.buildRootUrl() + "/add");
    },
    async showMoreItem() {
      await this.$router.push("/admin/users_scroll");
    },
    async editItem(item) {
      let url_route = this.buildRootUrl() + "/edit/" + item.id;
      if ((this.parentStoreUrl || this.storeName.toLowerCase()) == "cars_cms") url_route = "/admin/cars/edit/" + item.id;
      await this.$router.push(url_route);
    },
    async showItem(item) {
      let url_route = "/show/" + item.id;
      if ((this.parentStoreUrl || this.storeName.toLowerCase()) == "trakers") url_route = "/" + item.id + "/spot";
      await this.$router.push(this.buildRootUrl() + url_route);
    },
    async fundCoins(item) {
      let url_route = "/" + item.id + "/fund_coins";
      // if ((this.parentStoreUrl || this.storeName.toLowerCase()) == "trakers") url_route = "/" + item.id + "/spot";
      await this.$router.push(this.buildRootUrl() + url_route);
    },
    async addOther() {
      await this.$router.push("request_extraction");
    },
    deleteItem(item) {
      this.selected_item = item;
      this.confirmDelete = true;
    },
    hideConfirmDelete() {
      this.confirmDelete = false;
    },
    async confirmDeleteItem() {
      const self = this;
      let route_delete = "/delete"

      if ((this.parentStoreUrl || this.storeName.toLowerCase()) == "rent_trakers") {
        route_delete = "/delete_all"
        this.selected_item = { ids: this.selected_item.data.map(val => val.id) }
      }

      self.$store
        .dispatch(this.storeName + route_delete, this.selected_item)
        .then(() => {
          this.allItems = this.allItems.filter(item => item.id !== this.selected_item.id)
          self.confirmDelete = false;
          if (this.total - 1 >= 0) {
            this.updateTotal(this.total - 1);
          }
        });
    },
    async exportCSV() {
      const self = this;
      const export_data = removeEmptyObject({ ...this.options }, [
        undefined,
        null,
        "",
      ]);
      await self.$store.dispatch(this.storeName + "/getApiExport", {
        ...export_data,
      });
    },
    async clearNotifications() {
      const self = this;
      await self.$store.dispatch("Notifications_request_cms/clearNotifications", {})
        .then(async response => {
          await self.getNotifications();
        });
    },
    async searchRows() { },
  },
};
